export function getStateString(state) {
  if(state == 0) {
    return '송장생성';
  } else if(state == 1) {
    return '해외대리점접수';
  } else if(state == 2) {
    return '해외대리점도착';
  } else if(state == 3) {
    return '공항이동';
  } else if(state == 4) {
    return '런던출발';
  } else if(state == 5) {
    return '인천도착';
  } else if(state == 6) {
    return '세관';
  } else if(state == 7) {
    return '택배 접수';
  } else if(state == 8) {
    return '택배 이동';
  } else if(state == 9) {
    return '택배 이동';
  } else if(state == 10) {
    return '배송완료';
  } else if(state == -1) {
    return '출고보류';
  }
  return 'NA';
}
export function getStateTimeString(item) {
  let trailing = "<br>";
  //console.log("Get State Time String " + item.awb);
  if(item.tracking != "" && item.tracking.length > 0) {
    try {
      item.tracking = item.tracking.replace(/\\n/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\r/g, "\\r")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f")
        .replace(/\r\n/g, " ");
// remove non-printable and other non-valid JSON chars
      item.tracking = item.tracking.replace(/[\u0000-\u0019]+/g,"");
      if(item.tracking.includes("집배원 :")) {
        console.log("Contains ");
        item.tracking = item.tracking.replace("집배원 :", "집배원 ");
      }
      if(item.tracking.includes('\n')) {
        console.log("Contains line change");
        item.tracking = item.tracking.replace('\n', "");
      }
      let trackings = JSON.parse(item.tracking);
      if (trackings != undefined && trackings.length > 0) {
        trailing += trackings[trackings.length - 1].statue + ' ' + trackings[trackings.length - 1].location + '<br>' + trackings[trackings.length - 1].date + ' ' + trackings[trackings.length - 1].time
      }
    } catch(e) {
      console.log("ERROR parsing AWB + " + item.id + " tracking " + item.tracking);
      console.log(e);
      return "Error";
    }
  }
  if(item.state == -1) {
    return '출고보류';
  }
  if(item.state == 0) {
    return '송장생성';
  } else if(item.state == 1) {
    return '해외대리점접수 ' + item.in_time;
  } else if(item.state == 2) {
    return '해외대리점도착 ' + item.prepare_out_time;
  } else if(item.state == 3) {
    return '공항이동 ' + item.out_time;
  } else if(item.state == 4) {
    return '런던출발 ' + getDateTime(item.departure_time);
  } else if(item.state == 5) {
    return '인천도착 ' + getDateTime(item.arrival_time);
  } else if(item.state == 6) {
    return '세관 ' + item.custom_time;
  } else if(item.state == 7) {
    return '택배 접수' + trailing;
  } else if(item.state == 8) {
    return '택배 이동' + trailing;
  } else if(item.state == 8) {
    return '택배 이동' + trailing;
  } else if(item.state == 10) {
    return '배송완료 ' + item.delivered_time;
  }
  return 'NA';
}
export function getStatusString(item) {
  let list = [];
  if(item.state >= 0) {
    list.push("생성: " + getDateTime(item.created_time));
  }
  if(item.state >= 1) {
    list.push("해외대리점접수: " + getDateTime(item.in_time));
  }
  if(item.state >= 2) {
    list.push("해외대리점도착: " + getDateTime(item.prepare_out_time));
  }
  if(item.state >= 3) {
    list.push("공항이동: " + getDateTime(item.out_time));
  }
  if(item.state >= 4) {
    list.push("런던출발: " + getDateTime(item.departure_time));
  }
  if(item.state >= 5) {
    list.push("인천도착: " + getDateTime(item.arrival_time) + " (한국시간)");
  }
  if(item.state >= 6) {
    if(item.custom_time !== '0000-00-00 00:00:00') {
      list.push("세관: " + getDateTime(item.custom_time) + " (한국시간)");
    }
  }
  if(item.state >= 7) {
    if(item.custom_cleared_time !== '0000-00-00 00:00:00') {
      list.push("세관통과: " + getDateTime(item.custom_cleared_time) + " (한국시간)");
    }
  }

  if(item.tracking.length > 0) {
    try {
      let trackings = JSON.parse(item.tracking);

      for (let i = 0; i < trackings.length; i++) {
        list.push(trackings[i].statue + ' ' + trackings[i].location + ' ' + trackings[i].date + ' ' + trackings[i].time)
      }
    }catch(e) {
      console.log("ERROR parsing AWB + " + item.id + " tracking " + item.tracking);
      console.log(e);
      return "Error";
    }
  }
  return list.join('<br>');
}
export function getDateTime(str) {
  if(str.length == 19) {
    str = str.replace(/-/g, '/');
    return str.substring(5, 16);
  }
  return str;
}
export function millisToDate(timestamp, splitter = '.') {
  if(timestamp == 0) {
    return "";
  }
  let date = new Date(timestamp);

  //

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;


  return yy + splitter + mm + splitter + dd;

}
export function convertToLocaleTime(dateTime) {
  return dateTime.substring(0,10) + 'T' + dateTime.substring(11, 16);
}
export function downloadFTADoc(id) {

  console.log("Search " + id);
  window.open(process.env.APP_URL + 'fta_generator_2.php?id=' + id, "_blank");
}

export function downloadFTADocMulti(ids) {

  console.log("Search " + ids);
  window.open(process.env.APP_URL + 'fta_generator_multi.php?ids=' + ids, "_blank");
}
export function moveToStatusPage(awb) {
  let url = "https://koapi.utasco.net/statusChecker.php?awb=" + awb;
  window.open(url);
}
export function copyToClipboard(val){
  var dummy = document.createElement("input");
  dummy.style.display = 'none';
  document.body.appendChild(dummy);

  dummy.setAttribute("id", "dummy_id");
  document.getElementById("dummy_id").value=val;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
}

export function escapeSpecialCharacters(val) {
  if(val === undefined || val === null || val.length === 0) {
    return "";
  }
  return val.replace(/[^a-zA-Z0-9.()\- ]/g, "");
}
export function escapeLineChange(val) {
  if(val === undefined || val === null || val.length === 0) {
    return "";
  }
  return val.replace(/\r\n/g," ").replace(/\n/g," ")
}
export function getTimeStamp() {

  let date = new Date();

  //

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;

  let hh = date.getHours().toString();
  if (hh.length == 1) hh = '0'+hh;

  let minute = date.getMinutes().toString();
  if (minute.length == 1) minute = '0'+minute;

  let second = date.getSeconds().toString();
  if (second.length == 1) second = '0'+second;

  // let today = new Date();
  // if(today.getFullYear().toString() === yy) {
  //   return mm+'.'+dd+' '+hh+':'+minute+':'+second;
  // }
  return yy+'-'+mm+'-'+dd+' '+hh+':'+minute+':'+second;

}
export function playSound() {
  const audio = new Audio("/static/sound/done.mp3");
  audio.play();
}
export function playWarningSound() {
  const audioWarning = new Audio("/static/sound/system-fault.mp3");
  audioWarning.play();
}
export function playWrongSound() {
  const audioWrong = new Audio("/static/sound/wrong.mp3");
  audioWrong.play();
}
export function getVersion() {
  return '1.91';
}



// WEBPACK FOOTER //
// ./src/api/Utils.js